/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KinnserPatientCreatedPatientSavedValuesInner } from './KinnserPatientCreatedPatientSavedValuesInner';
import {
    KinnserPatientCreatedPatientSavedValuesInnerFromJSON,
    KinnserPatientCreatedPatientSavedValuesInnerFromJSONTyped,
    KinnserPatientCreatedPatientSavedValuesInnerToJSON,
    KinnserPatientCreatedPatientSavedValuesInnerToJSONTyped,
} from './KinnserPatientCreatedPatientSavedValuesInner';

/**
 * The patient WellSky created; null unless status is succeeded
 * @export
 * @interface KinnserPatientCreatedPatient
 */
export interface KinnserPatientCreatedPatient {
    /**
     * WellSky MRN
     */
    patient_id: string;
    /**
     * 
     */
    patient_key: string;
    /**
     * 
     */
    episode_key: string;
    /**
     * 
     */
    patient_name?: string;
    /**
     * What WellSky held in the Add Patient form just before save, one entry per patient field
     */
    saved_values?: Array<KinnserPatientCreatedPatientSavedValuesInner>;
}

/**
 * Check if a given object implements the KinnserPatientCreatedPatient interface.
 */
export function instanceOfKinnserPatientCreatedPatient(value: object): value is KinnserPatientCreatedPatient {
    if (!('patient_id' in value) || value['patient_id'] === undefined) return false;
    if (!('patient_key' in value) || value['patient_key'] === undefined) return false;
    if (!('episode_key' in value) || value['episode_key'] === undefined) return false;
    return true;
}

export function KinnserPatientCreatedPatientFromJSON(json: any): KinnserPatientCreatedPatient {
    return KinnserPatientCreatedPatientFromJSONTyped(json, false);
}

export function KinnserPatientCreatedPatientFromJSONTyped(json: any, ignoreDiscriminator: boolean): KinnserPatientCreatedPatient {
    if (json == null) {
        return json;
    }
    return {
        
        'patient_id': json['patient_id'],
        'patient_key': json['patient_key'],
        'episode_key': json['episode_key'],
        'patient_name': json['patient_name'] == null ? undefined : json['patient_name'],
        'saved_values': json['saved_values'] == null ? undefined : ((json['saved_values'] as Array<any>).map(KinnserPatientCreatedPatientSavedValuesInnerFromJSON)),
    };
}

export function KinnserPatientCreatedPatientToJSON(json: any): KinnserPatientCreatedPatient {
    return KinnserPatientCreatedPatientToJSONTyped(json, false);
}

export function KinnserPatientCreatedPatientToJSONTyped(value?: KinnserPatientCreatedPatient | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patient_id': value['patient_id'],
        'patient_key': value['patient_key'],
        'episode_key': value['episode_key'],
        'patient_name': value['patient_name'],
        'saved_values': value['saved_values'] == null ? undefined : ((value['saved_values'] as Array<any>).map(KinnserPatientCreatedPatientSavedValuesInnerToJSON)),
    };
}

